export default __webpack_public_path__ + "static/media/Ballroll_00171.4fbde3b1.png";